import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faEraser } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from 'flowbite';

const LOWERCASE = 'abcdefghijklmnopqrstuvwxyz';
const UPPERCASE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const NUMBERS = '0123456789';
const SYMBOLS = '!@#$%^&*()_+~`|}{[]:;?><,./-=';
const EXCLUDE_CONFUSING = 'il1o0O';

const optionsTooltip = {
  placement: 'bottom',
  triggerType: 'click',
  onHide: () => {
      console.log('tooltip is shown');
  },
  onShow: () => {
      console.log('tooltip is hidden');
  },
  onToggle: () => {
      console.log('tooltip is toggled');
  },
};

// instance options with default values
const instanceOptions = {
  id: 'tooltipContent',
  override: true
};

const PasswordGenerator = () => {
  const [password, setPassword] = useState('');
  const [options, setOptions] = useState({
    includeLowercase: true,
    includeUppercase: true,
    includeNumbers: true,
    includeSymbols: false,
    excludeConfusing: false,
    length: 12,
  });

  const generatePassword = () => {
    let characterPool = '';

    if (options.includeLowercase) characterPool += LOWERCASE;
    if (options.includeUppercase) characterPool += UPPERCASE;
    if (options.includeNumbers) characterPool += NUMBERS;
    if (options.includeSymbols) characterPool += SYMBOLS;

    // Remove confusing characters if option is enabled
    if (options.excludeConfusing) {
      characterPool = characterPool
        .split('')
        .filter(char => !EXCLUDE_CONFUSING.includes(char))
        .join('');
    }

    let generatedPassword = '';
    for (let i = 0; i < options.length; i++) {
      const randomIndex = Math.floor(Math.random() * characterPool.length);
      generatedPassword += characterPool[randomIndex];
    }

    setPassword(generatedPassword);
  };

  const handleOptionChange = (option) => (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setOptions({ ...options, [option]: value });
  };

  const handleCopy = () => {
    const $targetEl = document.getElementById('tooltipContent');
    const $triggerEl = document.getElementById('tooltipButton');
    const tooltip = new Tooltip($targetEl, $triggerEl, optionsTooltip, instanceOptions);
    navigator.clipboard.writeText(password)
      .then(() => tooltip.show())
      // .catch(() => alert('Failed to copy!'));
  };

  useEffect(() => {
    if (options) {
      generatePassword()
    }
  }, [options])

  return (
    <div className="grid grid-cols-1 xl:grid-cols-1 xl:gap-4">
      <div className="col-span-2 xl:col-auto">
        <div className="p-4 mb-4 space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 text-gray-400  dark:border-gray-600">
            <div className="relative w-2/4">
              <div className="flex items-center mt-4">
                <input
                  checked={options.includeLowercase}
                  onChange={handleOptionChange('includeLowercase')}
                  id="checked-checkbox" type="checkbox"
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
                <label for="checked-checkbox" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Include lowercase letters</label>
              </div>
              <div className="flex items-center mt-4">
                <input
                  checked={options.includeUppercase}
                  onChange={handleOptionChange('includeUppercase')}
                  id="checked-checkbox" type="checkbox"
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
                <label for="checked-checkbox" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Include uppercase letters</label>
              </div>
              <div className="flex items-center mt-4">
                <input
                  checked={options.includeNumbers}
                  onChange={handleOptionChange('includeNumbers')}
                  id="checked-checkbox" type="checkbox"
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
                <label for="checked-checkbox" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Include numbers</label>
              </div>
              <div className="flex items-center mt-4">
                <input
                  checked={options.includeSymbols}
                  onChange={handleOptionChange('includeSymbols')}
                  id="checked-checkbox" type="checkbox"
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
                <label for="checked-checkbox" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Include symbols</label>
              </div>
              <div className="flex items-center mt-4">
                <input
                  checked={options.excludeConfusing}
                  onChange={handleOptionChange('excludeConfusing')}
                  id="checked-checkbox" type="checkbox"
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
                <label for="checked-checkbox" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Exclude confusing characters (i, l, 1, o, 0, O)</label>
              </div>
              <div className="items-center mt-4">
                {/* <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Password length</label>
                <input
                  type="number"
                  value={options.length}
                  onChange={handleOptionChange('length')}
                  min="4"
                  max="64"
                  className="bg-gray-50 border w-full border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  p-4 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  required={true}
                /> */}
                 <label className="block mt-4 mb-2 text-sm font-medium text-gray-900 dark:text-white">Password length ({options.length})</label>
                 <input onChange={handleOptionChange('length')} min={8} type="range" value={options.length} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700"></input>
              </div>
            </div>
          </div>
          <div className="px-4 py-2 text-gray-400 dark:border-gray-600">
            <div className="relative w-2/4">
              <input
                type="text"
                value={password}
                className="block p-4 w-full z-20 text-sm text-gray-900 bg-gray-50 rounded-lg rounded-s-gray-100 rounded-s-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-blue-500"
                placeholder="Password will be shown here automatically..."
              />
              <button
                type="button"
                onClick={handleCopy}
                id='tooltipButton'
                disabled={!password}
                className="absolute top-0 end-0 px-4 p-2.5 h-full text-sm font-medium text-white bg-blue-700 rounded-e-lg border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              >
                <FontAwesomeIcon icon={faCopy}/>
              </button>
              <div id="tooltipContent" class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700">
                Coppied
                <div class="tooltip-arrow" data-popper-arrow></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PasswordGenerator;
